import { render, staticRenderFns } from "./ModalConfigDiscount.vue?vue&type=template&id=3670ee5c&scoped=true"
import script from "./ModalConfigDiscount.vue?vue&type=script&lang=js"
export * from "./ModalConfigDiscount.vue?vue&type=script&lang=js"
import style0 from "./ModalConfigDiscount.vue?vue&type=style&index=0&id=3670ee5c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3670ee5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3670ee5c')) {
      api.createRecord('3670ee5c', component.options)
    } else {
      api.reload('3670ee5c', component.options)
    }
    module.hot.accept("./ModalConfigDiscount.vue?vue&type=template&id=3670ee5c&scoped=true", function () {
      api.rerender('3670ee5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Discount/ModalConfigDiscount.vue"
export default component.exports